import { Outlet } from "react-router-dom"

const SalePage = () => {
    return (
        <Outlet />
    );
};

export default SalePage;
